import { reactive } from 'vue'

export function useActivityDialog () {
  const state = reactive({
    isOpen: false,
    title: '',
    editId: null
  })

  const open = (config) => {
    const { title, editId } = config || {}
    state.title = title
    state.editId = editId
    state.isOpen = true
  }

  const close = () => {
    state.title = ''
    state.editId = null
    state.isOpen = false
  }

  return {
    state,
    open,
    close
  }
}
